<template>
  <!-- Modal terms -->
  <div
    class="modal fade"
    id="identity-file-ex"
    tabindex="-1"
    role="dialog"
    aria-labelledby="termsLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="termsLabel">{{ $t('T.C. Kimlik Doküman Örneği') }}</h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <img src="/img/ornek-dokumanlar/yenitc.png" class="full-width" />
          <img src="/img/ornek-dokumanlar/eskitc.png" class="full-width" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn_1" data-dismiss="modal">{{ $t('Kapat') }}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'UserTcIdentityModal',
};
</script>
